import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import en from '@/i18n/locales/en/common.json';
import ru from '@/i18n/locales/ru/common.json';
import uzLatn from '@/i18n/locales/uz-Latn/common.json';
import uzCyrl from '@/i18n/locales/uz-Cyrl/common.json';
import { env } from '@/lib/env';

export const SUPPORTED_LANGS = ['uz-Latn', 'uz-Cyrl', 'ru', 'en'] as const;
export type SupportedLang = (typeof SUPPORTED_LANGS)[number];

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { common: en },
      ru: { common: ru },
      'uz-Latn': { common: uzLatn },
      'uz-Cyrl': { common: uzCyrl },
    },
    fallbackLng: env.VITE_DEFAULT_LANG,
    supportedLngs: SUPPORTED_LANGS as readonly string[],
    defaultNS: 'common',
    ns: ['common'],
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'hoopla-pos:lang',
      caches: ['localStorage'],
    },
  });

export default i18n;
